// extracted by mini-css-extract-plugin
module.exports = {"root":"CounterpartyDetailView_root_2T6wh","inner":"CounterpartyDetailView_inner_2kI0O"};